import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header.jsx";
import ErrorButton from "../components/ErrorButton.jsx";
import InfoIcon from "../assets/icons/info-icon-green.svg";
import "../styles/pages/error_page.css";

const ErrorPage = () => {
    const navigate = useNavigate();

    return (
        <div className="error-page">
            <Header />
            <div className="error-page-content">
                <div className="error-info-block">
                    <span className="error-number"><i>404</i></span>
                    <span className="error-title">Ошибка!</span>
                    <ErrorButton
                        text="Вернуться на страницу авторизации"
                        icon={InfoIcon}
                        styleType="white"
                        onClick={() => navigate("/")}
                        className="error-button"
                    />
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
